import {
  Component,
  OnInit,
  Inject,
  Optional,
  Output,
  EventEmitter,
} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { AuthService, FilesService, FileItem } from "../../shared";
import { ProjectHandler, NewProjectSettings } from "modeler/project-handler";
import { concatMap, filter } from "rxjs/operators";
import {
  UntypedFormControl,
  Validators,
  UntypedFormGroup,
} from "@angular/forms";
import { SystemService } from "app/shared/system.service";
import { DialogService } from "app/dialogs/services/dialog.service";

@Component({
  selector: "app-new-project",
  templateUrl: "./new-project.component.html",
  styleUrls: ["./new-project.component.scss"],
})
export class NewProjectComponent implements OnInit {
  constructor(
    private auth: AuthService,
    private system: SystemService,
    private files: FilesService,
    private dialog: DialogService,
    @Optional() private dialogRef?: MatDialogRef<NewProjectComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public template?: boolean
  ) {
    this.auth.isAuthenticated
      .pipe(
        filter((v) => v),
        concatMap((_) => this.files.nextFileId())
      )
      .subscribe((id) => this.name.setValue(`Заказ ${id}`));
    this.files.getProjectTemplates().subscribe((list) => {
      if (list.length > 0) {
        this.templates = list;
      }
    });

    this.system.getSettings(NewProjectSettings).subscribe((defaults) => {
      this.defaults = defaults;
      this.length.setValue(defaults.length);
      this.width.setValue(defaults.width);
      this.height.setValue(defaults.height);
      this.thickness.setValue(defaults.thickness);
    });
  }

  ngOnInit() {}

  @Output() afterCreate = new EventEmitter<FileItem>();

  templates?: FileItem[];
  message?: string;

  useTemplates = new UntypedFormControl(false);
  name = new UntypedFormControl("", [Validators.required]);
  sizeValidators = [Validators.min(1000), Validators.max(50000)];
  length = new UntypedFormControl(5000, this.sizeValidators);
  width = new UntypedFormControl(4000, this.sizeValidators);
  height = new UntypedFormControl(2500, this.sizeValidators);
  thickness = new UntypedFormControl(100, [
    Validators.min(1),
    Validators.max(500),
  ]);
  form = new UntypedFormGroup({
    name: this.name,
    length: this.length,
    width: this.width,
    height: this.height,
    thickness: this.thickness,
  });
  creating = false;
  defaults: NewProjectSettings;

  checkError(err) {
    this.creating = false;
    if (err.error && err.error.paymentError) {
      this.dialog.openAlert({
        message: $localize`Isn't possible to create more orders for current tariff. Contact the service administrator`,
      });
    }
  }

  createProject() {
    if (!this.form.valid) {
      return;
    }
    this.creating = true;

    let command = ProjectHandler.createNewProject(
      this.defaults.extend({
        length: this.length.value,
        width: this.width.value,
        height: this.height.value,
        thickness: this.thickness.value,
      })
    );
    this.files.createProject(this.name.value, command, this.template).subscribe(
      (f) => {
        if (this.dialogRef) {
          this.dialogRef.close();
        }
        this.afterCreate.next(f);
      },
      (e) => this.checkError(e)
    );
  }

  createFromTemplate(template: FileItem) {
    if (!this.name.valid) {
      return;
    }
    this.creating = true;
    let command = {
      type: "load",
      undo: "clear",
      file: template.id,
      flushModelId: template.id.toString(),
    };
    this.files.createProject(this.name.value, command).subscribe(
      (f) => {
        if (this.dialogRef) {
          this.dialogRef.close();
        }
        this.afterCreate.next(f);
      },
      (e) => this.checkError(e)
    );
  }

  cancel() {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }
}
